import {
  SearchBox,
  WhiteInstantSearchBuilder
} from '@white-nl/instantsearch-components';
import Menu from './components/search/refinements/Menu';
import Hit from './components/search/results/Hit';
import Pagination from './components/search/pagination/Pagination';
import NoResults from './components/search/results/NoResults';
import Loading from './components/search/results/Loading';

const searchContainer = document.getElementById('search');
const settings = searchContainer?.dataset || null;
const searchTranslateUrl = settings?.searchTranslateUrl;

const setSearchInputAriaLabelFromPlaceholder = (container: HTMLElement) => {
  const setAriaLabel = (): boolean => {
    const searchInput = container.querySelector<HTMLInputElement>('#white-instant-search-search-box input[type="search"]');

    if (!searchInput) {
      return false;
    }

    const placeholder = searchInput.getAttribute('placeholder');

    if (placeholder && searchInput.getAttribute('aria-label') !== placeholder) {
      searchInput.setAttribute('aria-label', placeholder);
    }

    return true;
  };

  if (setAriaLabel()) {
    return;
  }

  const observer = new MutationObserver(() => {
    if (setAriaLabel()) {
      observer.disconnect();
    }
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
  });
};

if (searchContainer && settings && searchTranslateUrl) {
  fetch(searchTranslateUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  }).then((res) => res.json())
    .then((search) => {
      const whiteInstantSearchSearch = new WhiteInstantSearchBuilder();
      whiteInstantSearchSearch
        .withSearchkit(
          settings.indexName || '',
          settings.publicUrl || '',
          settings.jwt || '',
          settings.refreshUrl || '',
        )
        .withWhiteInstantSearchRouting({
          baseUrl: settings.baseUrl,
          addToPath: true,
          addTrailingSlashesToUrls: true,
        })
        .addAdditionalData({
          locale: settings.locale,
          siteHandle: settings.siteHandle,
          baseUrl: settings.baseUrl,
          search: search,
        })
        .addStatsComponent([
          {
            component: ({ stats }) => (
              stats.query ? Craft.t(search, 'Search result for "{query}"', {query: stats.query } ) : Craft.t(search, 'All search results')
            ),
          },
        ])
        .setScrolling(
          {
            includeAttributes: ['page'],
          },
        )
        .addSearchingComponent([
          {
            settings: {
              placeholder: Craft.t(search, 'search_placeholder'),
              classNames: {
                form: 'flex relative mx-auto mb-3.5 lg:mb-12',
                input: 'w-full py-3 pl-3.5 pr-15 text-inherit placeholder:text-inherit text-base leading-normal outline-0 bg-white transition border-2 border-gray-850 appearance-none focus:border-brown-500',
                submit: 'flex items-center justify-center text-gray-950 w-12 absolute inset-y-0 right-0 rounded-3xl cursor-pointer transition-colors hover:text-orange-500 focus-visible:outline-none focus-visible:text-brown-500',
                submitIcon: 'w-4.75 fill-current',
                reset: 'hidden',
              }
            },
            component: SearchBox,
          },
        ])
        .addMenu([
          {
            settings: {
              attribute: 'searchType',
              classNames: {
                list: 'list-none flex gap-2 overflow-x-auto px-5',
                item: 'group',
                link: 'btn btn-sm btn-download text-nowrap items-center',
                count: 'text-xs font-light',
              }
            },
            component: Menu,
          },
        ])
        .setHitsPerPage(8)
        .addHitComponent([
          {
            component: Hit,
            noResultsComponent: NoResults,
            loadingComponent: Loading,
          }
        ])
        .addPaginationComponent([
          {
            component: Pagination,
          }
        ])
        .where(`siteHandle:${settings.siteHandle}`)
        .build()
        .show();

      setSearchInputAriaLabelFromPlaceholder(searchContainer);
    });
}
